import { Link } from "react-router-dom";
import type { ContentItem } from "@/mocks/content";
import { detailPath } from "@/lib/content";

const groupTone: Record<string, string> = {
  主角: "bg-accent-100 text-accent-900",
  配角: "bg-secondary-100 text-secondary-900",
  反派: "bg-primary-100 text-primary-800",
};

export default function CharacterCard({ item }: { item: ContentItem }) {
  return (
    <Link
      to={detailPath(item)}
      className="group flex flex-col items-center rounded-lg border border-background-200 bg-background-50 p-5 text-center transition-colors hover:border-primary-300"
    >
      <div className="h-24 w-24 overflow-hidden rounded-full border-2 border-background-200 bg-background-100 md:h-28 md:w-28">
        <img
          src={item.cover}
          alt={`${item.title} 角色形象图`}
          title={`${item.title} - 家庭教师动画平台`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="mt-4 flex items-center gap-2">
        <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {item.title}
        </h3>
        {item.group && (
          <span
            className={`rounded-full px-2 py-0.5 text-xs font-medium ${groupTone[item.group] ?? "bg-secondary-100 text-secondary-900"}`}
          >
            {item.group}
          </span>
        )}
      </div>
      <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">
        {item.subtitle}
      </p>
    </Link>
  );
}